// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd8bd304","239":"39b5d192","455":"fbc6d2d9"}[chunkId] + ".chunk.js";
};